import { StepStatus, WizardStep } from 'core/domain/wizard/wizard'

import useLoginUser from 'common/hooks/useLoginUser'

import { ActiveItemProps, DEFAULT_EDITING_CATEGORY_ITEM_INDEX } from '../SignUpNavigationMenu'
import { ADMIN_SIGNUP_PATH, RoutesMapping } from '../index'

export const getPercentageOfCompletedCategoryItems = (wizardState: WizardStep[]): number => {
  return Math.round((getNumberOfCompletedCategoryItems(wizardState) * 100) / getNumberOfCategoryItems(wizardState))
}

export const getNumberOfCategoryItems = (wizardState: WizardStep[] | undefined): number => {
  return wizardState ? wizardState.reduce((total, current) => total + (current ? current.children.length : 0), 0) : 0
}

export const getNumberOfCompletedCategoryItems = (wizardState: WizardStep[]): number => {
  return wizardState?.reduce(
    (total, current) =>
      total +
      (current ? current.children.filter((categoryItem) => categoryItem.status === StepStatus.Complete).length : 0),
    0,
  )
}

export const getNavigationItemFullPath = (item: WizardStep, productId: any): string => {
  const nextItemConfig = RoutesMapping.get(productId).find((m: any) => m.key === item.id)
  return ADMIN_SIGNUP_PATH + nextItemConfig?.route
}

export const getActiveItem = (
  currentPath: string,
  categories: WizardStep[],
  productId: any,
): ActiveItemProps | undefined => {
  try {
    if (currentPath === ADMIN_SIGNUP_PATH) {
      const categoryIndex = categories.findIndex((items) =>
        items.children.some((item) => item.status === StepStatus.Active),
      )
      if (categoryIndex === -1) throw new Error('Active Category not found')
      const categoryItem = categories[categoryIndex].children.find((item) => item.status === StepStatus.Active)
      return {
        categoryIndex: categoryIndex,
        categoryItemIndex: categoryItem ? categoryItem.priority : DEFAULT_EDITING_CATEGORY_ITEM_INDEX,
      }
    }

    const currentPathWithoutBase = currentPath.slice(ADMIN_SIGNUP_PATH.length)

    const item = RoutesMapping.get(productId).find((route: any) => route.route === currentPathWithoutBase)
    if (item === undefined) throw new Error('Item not found')

    const category = categories.find((category) =>
      category.children.some((categoryItem) => categoryItem.id === item.key),
    )
    if (category === undefined) throw new Error('Category not found')

    const categoryItem = category.children.find((categoryItem) => categoryItem.id === item.key)
    if (categoryItem === undefined) throw new Error('Category Item not found')

    return {
      categoryIndex: category.priority,
      categoryItemIndex: categoryItem.priority,
    }
  } catch (e) {
    console.log(currentPath)
    console.log(categories)
    console.log(e)
    return undefined
  }
}

export const GetNavigationItem = (
  currentPath: string,
  categories: WizardStep[],
  productId: any,
): ActiveItemProps | undefined => {
  try {
    const currentPathWithoutBase = currentPath.slice(ADMIN_SIGNUP_PATH.length)

    const item = RoutesMapping.get(productId).find((route: any) => route.route === currentPathWithoutBase)
    if (item === undefined) throw new Error('Item not found')

    const category = categories.find((category) =>
      category.children.some((categoryItem) => categoryItem.id === item.key),
    )
    if (category === undefined) throw new Error('Category not found')

    const categoryItem = category.children.find((categoryItem) => categoryItem.id === item.key)
    if (categoryItem === undefined) throw new Error('Category Item not found')
    return {
      categoryIndex: category.priority,
      categoryItemIndex: categoryItem.priority,
    }
  } catch (e) {
    console.log(currentPath)
    console.log(categories)
    console.log(e)
    return undefined
  }
}

export const GetCurrentActiveItem = (categories: WizardStep[]): WizardStep | undefined => {
  try {
    const categoryIndex = categories.findIndex((items) =>
      items.children.some((item) => item.status === StepStatus.Active),
    )
    if (categoryIndex === -1) throw new Error('Active Category not found')
    const categoryItem = categories[categoryIndex].children.find((item) => item.status === StepStatus.Active)
    return categoryItem ? categoryItem : categories[categoryIndex].children[0]
  } catch (e) {
    console.log(categories)
    console.log(e)
    return undefined
  }
}
